<template>
  <v-layout>
    <div
      class="py-14 sm:pb-36"
    >
      <div class="container max-w-md">
        <img
          src="/img/icons/svg/streamline-icon-task-checklist-check@48x48.svg"
          alt="Subscription"
          class="w-20 mx-auto mb-5"
        >

        <h1 class="title-1 mb-8 text-center">
          Billing
        </h1>


        <div class="card">
          <h2 class="title mb-5 text-2xl text-center">
            Congratulations !
          </h2>

          <p class="mb-4 leading-snug text-gray-600">
            Thanks to your subscription, you currently compensate {{ monthlyCarbonOffset }} tons of CO2 equivalent per month.
          </p>

          <p
            v-if="$laravel.user.is_subscribed"
            class="leading-snug text-gray-600"
          >
            You may cancel your subscription or modify your payment method by clicking on the link below:

            <a
              class="btn btn-primary w-full mt-5"
              href="/billing-portal"
              target="_blank"
            >
              <span>
                Billing portal
                <i class="mdi mdi-open-in-new" />
              </span>
            </a>
          </p>

          <p
            v-else
            class="mt-5 leading-tight text-gray-600"
          >
            You must subscribe to be able to access your billing portal
          </p>
        </div>
      </div>
    </div>
  </v-layout>
</template>
<script>
export default {
  name: "v-billing",
  computed: {
    monthlyCarbonOffset() {
      return (this.$laravel.user.carbon_footprint / 12).toPrecision(2);
    }
  }
};
</script>
